// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"ManageAdmins_overlayWrapper__TiS9S","viewBox":"ManageAdmins_viewBox__G3coA","tablestyle":"ManageAdmins_tablestyle__wsexw"};